import React from 'react';
import { Outlet } from 'react-router-dom';

import { AccountNotReadyWarningSection, Container, Section } from 'components';

const MoneyLayout = () => (
  <Section>
    <Container>
      <AccountNotReadyWarningSection />
      <Outlet />
    </Container>
  </Section>
);

export default MoneyLayout;
